import { jsx as _jsx } from "react/jsx-runtime";
import { ToastErrorBox, useToast } from 'shared/components';
import { useNoteSetupContext } from '../../note-setup';
import { UndoFormReason } from '../types';
import { useDeleteNoteMutation } from './useDeleteNoteMutation';
import { useUnsignNoteMutation } from './useUnsignNoteMutation';
export var useSubmitUndo = function (noteId, onSuccessDelete, onSuccessUnsign) {
    var _a, _b;
    var toast = useToast();
    var noteSetupData = useNoteSetupContext().data;
    var _c = useDeleteNoteMutation({
        onSuccess: onSuccessDelete,
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                duration: 15000,
                position: 'top',
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to delete note:", message: message }));
                },
            });
        },
        appointmentId: (_a = noteSetupData === null || noteSetupData === void 0 ? void 0 : noteSetupData.appointment) === null || _a === void 0 ? void 0 : _a.id,
    }), deleteMutate = _c.mutate, deleteLoading = _c.isLoading;
    var _d = useUnsignNoteMutation({
        onSuccess: onSuccessUnsign,
        onError: function (error) {
            var _a, _b;
            var message = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            toast({
                status: 'error',
                duration: 15000,
                position: 'top',
                render: function (_a) {
                    var onClose = _a.onClose;
                    return (_jsx(ToastErrorBox, { onClose: onClose, title: "Failed to unsign note:", message: message }));
                },
            });
        },
        appointmentId: (_b = noteSetupData === null || noteSetupData === void 0 ? void 0 : noteSetupData.appointment) === null || _b === void 0 ? void 0 : _b.id,
    }), unsignMutation = _d.mutate, unsignLoading = _d.isLoading;
    var submit = function (data) {
        var _a;
        if (data.reason === UndoFormReason.arrivedLate) {
            unsignMutation({
                id: noteId,
            });
        }
        else {
            deleteMutate({
                id: noteId,
                reason: (_a = data.reason) !== null && _a !== void 0 ? _a : '',
            });
        }
    };
    return {
        submit: submit,
        isLoading: deleteLoading || unsignLoading,
    };
};
